<template>
    <div class="d-inline position-relative">
        <div class="d-inline">
            <span v-if="!value.changeStatusTo" class="lightest radius-normal px-2 py-1" :class="getReservationState(value.status).cssClass" >
                {{getReservationState(value.status).label}}
                <span v-if="getReservationState(value.status).allowChange && !disabled" @click.stop="toggleShowOptions" class="pointer"><i class="mr-0 ml-2 ico ico-arrow-bottom"></i></span>
            </span>

            <span v-else class="lightest radius-normal px-2 py-1" :class="getReservationState(value.changeStatusTo).cssClass" >
                {{getReservationState(value.changeStatusTo).label}}
                <span v-if="getReservationState(value.changeStatusTo).allowChange" @click.stop="toggleShowOptions" class="pointer"><i class="mr-0 ml-2 ico ico-arrow-bottom"></i></span>
            </span>
        </div>

        <div class="optionsHolder radius-normal p-2 border-light" v-if="optionsHolderOpen" v-click-outside="toggleShowOptions">
            <div v-for="option in getAllReservationStates" :key="option.id">
                <button
                    v-if="option.isOption"
                    class="lightest radius-normal border-0 w-100 px-2 py-1 mb-2 text-center pointer"
                    :class="option.cssClass"
                    :disabled="statusBtnValidation(option)"
                    @click="selectOption(option, option.code)"
                >
                    {{option.label}}
                </button>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapActions, mapGetters } from 'vuex'
    import { reservationsMixin } from '@/mixins/reservations'

    export default {
        data() {
            return {
                optionsHolderOpen: false
            }
        },
        mixins:[
            reservationsMixin
        ],
        props:{
            value: { // <- reservation
                type: Object,
            },
            disabled: {
                type: Boolean,
                default: false
            }
        },
        computed: {
            ...mapGetters([
                'getAllReservationStates',
                'getReservationState',
            ]),
            reservation() {
                return this.value;
            }
        },
        methods: {
            ...mapActions([
                'closeModal',
                'openModal',
                'openReservationById',
            ]),
            statusBtnValidation(option) {
                return  this.value.changeStatusTo ? option.code == this.value.changeStatusTo : option.code == this.value.status;
            },
            openReservation(reservationNr) {
                this.closeModal();
                this.openReservationById(reservationNr);
            },
            toggleShowOptions() {
                if (!this.disabled) {
                    this.optionsHolderOpen = !this.optionsHolderOpen;
                }
            },
            selectOption(option, id) {
                this.toggleShowOptions();

                // Now we take note of the desired future status and only change it on save (update) reservation
                // if the reservation is from GetYourGide AND we are changing it to "canceled" the status should be -6 (pending cancelation)
                // in all the other cases we set to -5 as normal
                if (this.value.channelType == '202' && id == "-5" && this.value.status != '-5') {
                    this.$set(this.value, 'changeStatusTo', "-6");
                } else {
                    this.$set(this.value, 'changeStatusTo', id);
                }

                // if cancel/pending cancel (status -5 or -6) and original status diferent from cancelled
                if((this.value.changeStatusTo == '-5' || this.value.changeStatusTo == '-6') && this.value.status != '-5') {
                    this.openModal('ReservationCancelReason');
                }

                this.applyChanges();
                this.$forceUpdate();
            },
            applyChanges() {
                this.$emit('value', this.value);
            }
        }
    }
</script>

<style lang="scss" scoped>
    .optionsHolder {
        position: absolute;
        background: #FFF;
        top: 100%;
        left: 0;
        z-index: 5;
        width: 150px;
        margin-top: 0.2rem;
    }
</style>



// WEBPACK FOOTER //
// changeStatusBtn.vue?62b8dadb